"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DolyamiBig = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DolyamiBig = function DolyamiBig(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.019 34.459l-2.267-2.511h-1.325v5.813h1.383v-3.709l2.07 2.197h.255l2.034-2.197v3.709h1.384v-5.813h-1.325l-2.21 2.51zm10.126-2.511l-3.429 3.778v-3.778h-1.383v5.813H45.6l3.43-3.778v3.778h1.383v-5.813h-1.268zm-21.171 2.127c0 .925.508 1.655 1.288 1.96l-1.463 1.726h1.694l1.33-1.57h1.44v1.57h1.383v-5.813h-3.522c-1.314 0-2.15.895-2.15 2.127zm4.29-.847v1.72H30.38c-.628 0-.965-.35-.965-.861 0-.512.349-.86.965-.86l1.883.001zm-10.72-.118c-.084 2-.508 3.29-1.337 3.29H20v1.396l.221.011c1.662.093 2.58-1.36 2.732-4.534h2.186v4.488h1.38v-5.813h-4.928l-.047 1.163zm-5.208-1.243c-1.871 0-3.218 1.29-3.218 2.987 0 1.755 1.465 3 3.218 3 1.825 0 3.244-1.314 3.244-3s-1.419-2.987-3.244-2.987zm0 4.592c-1.058 0-1.778-.686-1.778-1.605 0-.942.721-1.609 1.778-1.609 1.056 0 1.802.698 1.802 1.609s-.756 1.605-1.802 1.605zm-4.686-4.5H6.767l-.046 1.163c-.07 1.674-.508 3.267-1.337 3.29L5 36.424v2.71h1.395v-1.372h4.848v1.371h1.407v-2.721h-1v-4.453zm-1.383 4.453H7.314c.5-.755.767-1.848.814-3.127h2.139v3.127z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.707,
    y: 0.867,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.91 6.867h2.083v9h-2.084v-9zm-4.167 1h2.083v9h-2.083v-9zm-2.084 1h-2.083v9h2.083v-9zm-6.25 1h2.084v9h-2.084v-9z",
    fill: "#000"
  }));
};

exports.DolyamiBig = DolyamiBig;
var _default = DolyamiBig;
exports.default = _default;